var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisibilityOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.095,
    height: 37.866,
    viewBox: "0 0 41.095 37.866",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a5a9c7;}.b{fill:none;stroke:#a5a9c7;stroke-linecap:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2.121)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M33.548-39A22.092,22.092,0,0,0,13-24.99,22.092,22.092,0,0,0,33.548-10.98,22.092,22.092,0,0,0,54.1-24.99,22.092,22.092,0,0,0,33.548-39Zm0,23.35a9.343,9.343,0,0,1-9.34-9.34,9.343,9.343,0,0,1,9.34-9.34,9.343,9.343,0,0,1,9.34,9.34A9.343,9.343,0,0,1,33.548-15.65Zm0-14.944a5.6,5.6,0,0,0-5.6,5.6,5.6,5.6,0,0,0,5.6,5.6,5.6,5.6,0,0,0,5.6-5.6A5.6,5.6,0,0,0,33.548-30.594Z",
    transform: "translate(-13 41.8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M33.624,0,0,33.623",
    transform: "translate(4.667)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityOff);
export default __webpack_public_path__ + "static/media/visibilityOff.310d3c84.svg";
export { ForwardRef as ReactComponent };